module.exports = __webpack_public_path__ + "img/MUZIK132_air_900x471.8a29bee8.jpg";